import { useMemo } from "react";
import { useAppSelector } from ".";
import { TP_REDEMPTION_RATE } from "../@types/Constants";
import { isLoggedInSelector } from "../redux/slices/Member/member";
import { selectHotelRates } from "../redux/slices/Rate/rate";
/**
 * Custom hook to determine if redemption is available for a room in a hotel.
 *
 * @param {object} options - The options for the hook.
 * @param {object} options.room - The room details.
 * @param {string} options.hotelCode - The hotel code.
 * @returns {boolean} - True if redemption is available for the room, otherwise false.
 */
export const useRedemption = ({
  room,
  hotelCode,
}: {
  room: any;
  hotelCode: string;
}): void => {
  // const dispatch = useAppDispatch();
  const isMemberLoggedIn = useAppSelector(isLoggedInSelector);
  // const crmProfile = useAppSelector(crmProfileSelector);
  const searchState = useAppSelector((state: any) => state.search);
  // const checkout = useAppSelector((state: any) => state.checkout);
  const hotelRates: any = useAppSelector(
    selectHotelRates([hotelCode as string])
  );
  const redemptionItem = hotelRates[hotelCode as string]?.redemptionItem;
  // const memberId = crmProfile?.memberId;

  // Calculate whether the room has a redemption rate using useMemo for memoization
  const hasRedemptionRate = useMemo(() => {
    return room.Rates?.some(
      (rate: any) =>
        rate.isRedemptionRate && TP_REDEMPTION_RATE?.includes(rate.rateCode)
    );
  }, [room.Rates]);

  // Calculate whether redemption is available based on certain conditions
  const isRedemptionAvailable = useMemo(() => {
    return (
      isMemberLoggedIn &&
      hasRedemptionRate &&
      redemptionItem?.currencyRequired &&
      searchState?.rooms?.length <= 1
    );
  }, [isMemberLoggedIn, hasRedemptionRate, redemptionItem, searchState.rooms]);

  return isRedemptionAvailable; // Return the result
};
